
import { MethodEntity, KnowledgeEntity } from '../types';
import { getDB } from '../lib/db';
import { apiClient, isCloud } from '../lib/apiClient';

// Methods
export const getMethods = async (): Promise<MethodEntity[]> => {
  if (isCloud) {
    return await apiClient('/methods');
  } else {
    const db = await getDB();
    const methods = await db.getAll('methods');
    return methods.sort((a, b) => (b.updatedAt || b.createdAt) - (a.updatedAt || a.createdAt));
  }
};

export const saveMethod = async (m: MethodEntity): Promise<void> => {
  if (isCloud) {
    await apiClient('/methods', {
        method: 'POST',
        body: JSON.stringify(m)
    });
  } else {
    const db = await getDB();
    await db.put('methods', m);
  }
};

export const deleteMethod = async (id: string): Promise<void> => {
    if (isCloud) {
       await apiClient(`/methods/${id}`, { method: 'DELETE' });
    } else {
       const db = await getDB();
       await db.delete('methods', id);
    }
};

export const hydrateMethod = async (m: MethodEntity): Promise<MethodEntity> => {
    // Placeholder for future rich text hydration if method content gets too large
    return m;
};

// Knowledge
export const getKnowledge = async (): Promise<KnowledgeEntity[]> => {
  if (isCloud) {
    return await apiClient('/knowledge');
  } else {
    const db = await getDB();
    const knowledge = await db.getAll('knowledge');
    return knowledge.sort((a, b) => b.createdAt - a.createdAt);
  }
};

export const saveKnowledge = async (k: KnowledgeEntity): Promise<void> => {
  if (isCloud) {
    await apiClient('/knowledge', {
        method: 'POST',
        body: JSON.stringify(k)
    });
  } else {
    const db = await getDB();
    await db.put('knowledge', k);
  }
};

export const deleteKnowledge = async (id: string): Promise<void> => {
    if (isCloud) {
       await apiClient(`/knowledge/${id}`, { method: 'DELETE' });
    } else {
       const db = await getDB();
       await db.delete('knowledge', id);
    }
};
